<template>
  <div class="zui-selector-field" :class="{ 'label-position-top': labelPosition == 'top' }">
    <zui-field
      class="field"
      :padding="padding"
      :label-position="labelPosition"
      :label-style="labelStyle"
      :round="round"
      :show-shadow="showShadow"
      :label="label"
      :clickable="false"
      :required="required"
      :hide-label="hideLabel"
    >
      <template #accessory>
        <zui-selector
          class="selector"
          v-model="value"
          :options="options"
          :multiple="multiple"
          optionPadding="0px 0px"
          :direction="direction"
          :disabled="readonly"
        />
      </template>
    </zui-field>
  </div>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: Array,
  options: Array,
  multiple: Boolean,
  round: Boolean,
  showShadow: Boolean,
  labelPosition: String,
  // weak/normal/strong
  labelStyle: String,
  label: String,
  required: Boolean,
  readonly: Boolean,
  padding: String,
  hideLabel: Boolean,

  // 显示方向 row/column
  direction: {
    type: String,
    default: 'row'
  }
})

const value = ref(props.modelValue)
watch(
  () => props.modelValue,
  (val) => {
    value.value = val
  }
)
watch(value, (val) => {
  emit('update:modelValue', val)
})
</script>
<style lang="scss" scoped>
.zui-selector-field {
  &.label-position-top {
    .selector {
      width: 100%;
      margin-top: 4px;
    }
  }
}
</style>
